module.exports = "<bustype-page></bustype-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bustype.html
// module id = 1564
// module chunks = 0